(function () {
  var root = document.querySelector('[data-pdp-costumi]');
  var form = document.querySelector('form.product-single__form');
  var addButton = form && form.querySelector('[data-add-to-cart]');

  if (!root || !form || !addButton || document.querySelector('.pdp-costumi-sticky')) return;

  document.body.classList.add('template-product-costumi');

  var title = document.querySelector('.product-single__title');
  var price = document.querySelector('[data-product-price]');
  var availability = root.querySelector('[data-costumi-availability]');
  var inventoryNode = document.querySelector('[data-costumi-inventory-json]');
  var stockMessage = root.querySelector('[data-costumi-stock-message]');
  var stockLabel = root.querySelector('.pdp-costumi__stock-label');
  var stockBar = root.querySelector('[data-costumi-stock-bar]');
  var inventory = {};
  var installmentPrices = document.querySelectorAll('[data-costumi-installment-price]');
  var paypalMessage = document.querySelector('[data-pp-message]');
  var sticky = document.createElement('div');

  if (inventoryNode) {
    try {
      inventory = JSON.parse(inventoryNode.textContent);
    } catch (error) {
      inventory = {};
    }
  }

  sticky.className = 'pdp-costumi-sticky';
  sticky.setAttribute('aria-hidden', 'true');
  sticky.innerHTML =
    '<div class="pdp-costumi-sticky__meta">' +
      '<div class="pdp-costumi-sticky__title"></div>' +
      '<div class="pdp-costumi-sticky__price"></div>' +
    '</div>' +
    '<button type="button" class="pdp-costumi-sticky__button">Aggiungi</button>';

  sticky.querySelector('.pdp-costumi-sticky__title').textContent =
    title ? title.textContent.trim() : 'Costume 011-EXPRESS';
  sticky.querySelector('.pdp-costumi-sticky__price').textContent =
    price ? price.textContent.trim() : '';

  document.body.appendChild(sticky);
  document.body.classList.add('has-pdp-costumi-sticky');

  var stickyButton = sticky.querySelector('.pdp-costumi-sticky__button');

  stickyButton.addEventListener('click', function () {
    addButton.click();
  });

  function updateState() {
    var disabled = addButton.disabled || addButton.getAttribute('aria-disabled') === 'true';
    var variantSelect = form.querySelector('[name="id"]');
    var variant = variantSelect ? inventory[variantSelect.value] : null;

    stickyButton.disabled = disabled;
    stickyButton.textContent = disabled ? 'Esaurito' : 'Aggiungi';

    if (price) {
      sticky.querySelector('.pdp-costumi-sticky__price').textContent = price.textContent.trim();
    }

    if (variantSelect && installmentPrices.length) {
      var selectedOption = variantSelect.options[variantSelect.selectedIndex];
      var priceCents = selectedOption && selectedOption.dataset
        ? Number(selectedOption.dataset.price || 0)
        : 0;

      if (!priceCents && price) {
        priceCents = Number(price.textContent.replace(/[^\d,]/g, '').replace(',', '.')) * 100;
      }

      if (priceCents) {
        if (paypalMessage) {
          paypalMessage.setAttribute('data-pp-amount', (priceCents / 100).toFixed(2));
        }

        var currency = window.Shopify && window.Shopify.currency
          ? window.Shopify.currency.active
          : 'EUR';
        var installment = new Intl.NumberFormat(
          document.documentElement.lang || 'it-IT',
          { style: 'currency', currency: currency }
        ).format(priceCents / 300);

        installmentPrices.forEach(function (node) {
          node.textContent = installment;
        });
      }
    }

    if (availability) {
      availability.textContent = disabled
        ? 'Questa taglia non e al momento disponibile.'
        : 'Disponibile ora nella taglia selezionata.';
    }

    if (stockMessage && stockLabel && stockBar) {
      if (disabled || (variant && !variant.available)) {
        stockMessage.textContent = 'Taglia non disponibile';
        stockLabel.textContent = 'Esaurita';
        stockBar.style.width = '5%';
      } else if (variant && variant.managed && variant.quantity <= 10) {
        stockMessage.textContent = 'Solo ' + variant.quantity + ' disponibili nella taglia selezionata';
        stockLabel.textContent = 'Scorte limitate';
        stockBar.style.width = Math.max(12, variant.quantity * 8) + '%';
      } else {
        stockMessage.textContent = 'Disponibile nella taglia selezionata';
        stockLabel.textContent = 'Pronta consegna';
        stockBar.style.width = '88%';
      }
    }
  }

  function updateVisibility() {
    var rect = addButton.getBoundingClientRect();
    var visible = rect.bottom < 0 || rect.top > window.innerHeight;

    sticky.classList.toggle('is-visible', visible);
    sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
  }

  document.addEventListener('change', function () {
    window.setTimeout(updateState, 50);
  });
  window.addEventListener('scroll', updateVisibility, { passive: true });
  window.addEventListener('resize', updateVisibility);

  updateState();
  updateVisibility();
})();
